export const FEATURE_GUID_ALIASES: Readonly<Record<string, readonly string[]>> = {
  // retired account:update_notifications → notifications:read + notifications:update
  'f2c5db56-8e40-4fa1-b234-9f1f2e3c0003': [
    'e6a1b83b-a8fe-4044-a2dd-b33291d4aaae',
    '899d8291-294a-4de9-b15d-0dbd4e956e8a',
  ],
};
